import DataLoader from 'dataloader'

export function createDataLoader<Result>(loader: (keys: string[]) => Promise<Result[]>) {
	return new DataLoader<string, Result, string>(keys => loader([...keys]))
}
